/**
 * Simplified MIDI file parser using @tonejs/midi
 */

import { Midi } from '@tonejs/midi';
import { ParsedMidiFile, MidiFileNote, MidiFileControlChange } from './midiTypes';

export async function parseMidiFile(file: File): Promise<ParsedMidiFile> {
  const arrayBuffer = await file.arrayBuffer();
  const midi = new Midi(arrayBuffer);
  
  const notes: MidiFileNote[] = [];
  const controlChanges: MidiFileControlChange[] = [];
  
  midi.tracks.forEach(track => {
    track.notes.forEach(note => {
      notes.push({
        note: note.midi,
        velocity: Math.round(note.velocity * 127),
        time: note.time,
        duration: note.duration,
        channel: 0
      });
    });
    
    Object.values(track.controlChanges).forEach(ccArray => {
      ccArray.forEach(cc => {
        controlChanges.push({
          controller: cc.number,
          value: Math.round(cc.value * 127),
          time: cc.time,
          channel: 0
        });
      });
    });
  });
  
  notes.sort((a, b) => a.time - b.time);
  controlChanges.sort((a, b) => a.time - b.time);
  
  return {
    notes,
    controlChanges,
    duration: Math.max(
      notes.length > 0 ? Math.max(...notes.map(n => n.time + n.duration)) : 0,
      controlChanges.length > 0 ? Math.max(...controlChanges.map(cc => cc.time)) : 0
    ),
    ticksPerQuarter: midi.header.ppq,
    name: file.name
  };
}